import {useFormContext} from "react-hook-form"
import {cn} from "@/lib/utils";
import {ComponentProps} from "react";
import {FORM_ROOT} from "@/components/form/const";


export function ErrorFormField({ className, ...props }: ComponentProps<"div">) {
    const form = useFormContext()
    const { errors } = form.formState
    const error = errors?.[FORM_ROOT]
    if (!error?.message) {
        return null
    }
    return <div
        className={cn("p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400")}
        role="alert"
        {...props}
    >
        {error.message.toString()}
    </div>
}

ErrorFormField.displayName = "ErrorFormField";
